exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.headerText[data-v-14bccd20] {\n    color: rgba(0, 0, 0, 0.6);\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.1px\n}\n", ""]);
